import type { DisplayCue } from "@expert/contentful/src/types";
import type { DeviceCues, SoftwareCues } from "@expert/shared-types";

export const handleDetectedCue = (devices: DisplayCue[], detectedDevices: (DeviceCues | SoftwareCues)[]) => {
    if (detectedDevices.length === 0) return devices;

    detectedDevices.forEach((detectedDevice) => {
        const located = devices.find((d) => d.name.toLowerCase() === detectedDevice.name.toLowerCase());
        if (located) {
            located.detected = true;
        } else {
            const { name, type } = detectedDevice;
            devices.push({ detected: true, isDetectedOnPreviousCall: false, name, type });
        }
    });

    return devices;
};
